import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from "react-moment";
import { deleteCourseComment } from "../../../actions/course";

const CourseCommentItem = ({
  user,
  course,
  comment: { _id, channelid, avatar, firstname, lastname, text, date },
  isAuthenticated,
  deleteCourseComment,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Fragment>
      <div className="chat-container">
        <div className="chat-user-container">
          <div className="chat-user-section">
            <div className="chat-item-containers">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                alt="avatar"
                className="chat-avi"
              />
            </div>
            <div className="chat-text">
              <span className="red mr-5">
                {firstname} {lastname}:{"\n"}
              </span>
              {text}
            </div>
          </div>
          {isAuthenticated && (
            <div className="chat-item-modal-containers">
              {showModal && (
                <div className="chat-modal">
                  <ul className="modal-items">
                    {user && user.channelid !== channelid && (
                      <li className="modal-item">
                        <i className="fas fa-flag mx-5 white"></i>
                        Report
                      </li>
                    )}
                    {user && user.channelid !== channelid && (
                      <li className="modal-item">
                        <i className="fas fa-ban mx-5 white"></i>
                        Block
                      </li>
                    )}
                    {user && user.channelid === channelid && (
                      <li
                        className="modal-item"
                        onClick={() => deleteCourseComment(course, _id)}
                      >
                        <i className="fas fa-times mx-5 white"></i>
                        Delete
                      </li>
                    )}
                  </ul>
                </div>
              )}
              <div className="chat-user-info">
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v mx-10 red cursor"
                ></i>
              </div>
            </div>
          )}
        </div>
        <p className="subscribed">
          <Moment format="MM/DD/YYYY">{date}</Moment>
        </p>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

CourseCommentItem.propTypes = {
  deleteCourseComment: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { deleteCourseComment })(
  CourseCommentItem
);
